/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SortEnumType = "ASC" | "DESC" | "%future added value";
export type LicensingAnimalSortInput = {
    name?: SortEnumType | null | undefined;
};
export type AnimalListQueryVariables = {
    first: number;
    after?: string | null | undefined;
    order: Array<LicensingAnimalSortInput>;
};
export type AnimalListQueryResponse = {
    readonly configuration: {
        readonly organisationContact: string;
        readonly " $fragmentRefs": FragmentRefs<"AnimalRow_configuration">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"AnimalList_query">;
};
export type AnimalListQuery = {
    readonly response: AnimalListQueryResponse;
    readonly variables: AnimalListQueryVariables;
};



/*
query AnimalListQuery(
  $first: Int!
  $after: String
  $order: [LicensingAnimalSortInput!]!
) {
  ...AnimalList_query
  configuration {
    organisationContact
    ...AnimalRow_configuration
  }
}

fragment AnimalList_query on Query {
  account {
    animals(first: $first, after: $after, order: $order) {
      edges {
        node {
          id
          status
          licences {
            isLifetime
            id
          }
          name
          ...AnimalRow_animal
          __typename
        }
        cursor
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
}

fragment AnimalRow_animal on LicensingAnimal {
  id
  name
  breed {
    name
  }
  secondaryBreed {
    name
  }
  status
  licenceType {
    description
  }
  currentLicence {
    id
    description
    isLifetime
    expiryDate
  }
  animalType {
    id
    description
  }
  ...AnimalStatus_animal
}

fragment AnimalRow_configuration on Configuration {
  organisationContact
  ...AnimalStatus_configuration
}

fragment AnimalStatus_animal on LicensingAnimal {
  id
  status
  currentLicence {
    id
    status
    isLifetime
    expiryDate
  }
}

fragment AnimalStatus_configuration on Configuration {
  organisationContact
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "order"
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organisationContact",
        "storageKey": null
    } as any, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        } as any,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        } as any,
        {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
        } as any
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLifetime",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v9 = [
        (v8 /*: any*/)
    ], v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AnimalListQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AnimalRow_configuration"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AnimalList_query"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AnimalListQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": (v4 /*: any*/),
                            "concreteType": "LicensingAnimalConnection",
                            "kind": "LinkedField",
                            "name": "animals",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LicensingAnimalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LicensingAnimal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Licence",
                                                    "kind": "LinkedField",
                                                    "name": "licences",
                                                    "plural": true,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v5 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v8 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "LicensingBreed",
                                                    "kind": "LinkedField",
                                                    "name": "breed",
                                                    "plural": false,
                                                    "selections": (v9 /*: any*/),
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "LicensingBreed",
                                                    "kind": "LinkedField",
                                                    "name": "secondaryBreed",
                                                    "plural": false,
                                                    "selections": (v9 /*: any*/),
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "LicenceType",
                                                    "kind": "LinkedField",
                                                    "name": "licenceType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v10 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Licence",
                                                    "kind": "LinkedField",
                                                    "name": "currentLicence",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "expiryDate",
                                                            "storageKey": null
                                                        },
                                                        (v6 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "LicensingAnimalType",
                                                    "kind": "LinkedField",
                                                    "name": "animalType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v10 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "__typename",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "cursor",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalCount",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endCursor",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasNextPage",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v4 /*: any*/),
                            "filters": [
                                "order"
                            ],
                            "handle": "connection",
                            "key": "AnimalList_query_animals",
                            "kind": "LinkedHandle",
                            "name": "animals"
                        },
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Configuration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "48009558f86d97e77c318ee1a2e5b130",
            "id": null,
            "metadata": {},
            "name": "AnimalListQuery",
            "operationKind": "query",
            "text": "query AnimalListQuery(\n  $first: Int!\n  $after: String\n  $order: [LicensingAnimalSortInput!]!\n) {\n  ...AnimalList_query\n  configuration {\n    organisationContact\n    ...AnimalRow_configuration\n  }\n}\n\nfragment AnimalList_query on Query {\n  account {\n    animals(first: $first, after: $after, order: $order) {\n      edges {\n        node {\n          id\n          status\n          licences {\n            isLifetime\n            id\n          }\n          name\n          ...AnimalRow_animal\n          __typename\n        }\n        cursor\n      }\n      totalCount\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment AnimalRow_animal on LicensingAnimal {\n  id\n  name\n  breed {\n    name\n  }\n  secondaryBreed {\n    name\n  }\n  status\n  licenceType {\n    description\n  }\n  currentLicence {\n    id\n    description\n    isLifetime\n    expiryDate\n  }\n  animalType {\n    id\n    description\n  }\n  ...AnimalStatus_animal\n}\n\nfragment AnimalRow_configuration on Configuration {\n  organisationContact\n  ...AnimalStatus_configuration\n}\n\nfragment AnimalStatus_animal on LicensingAnimal {\n  id\n  status\n  currentLicence {\n    id\n    status\n    isLifetime\n    expiryDate\n  }\n}\n\nfragment AnimalStatus_configuration on Configuration {\n  organisationContact\n}\n"
        }
    } as any;
})();
(node as any).hash = 'd5c61f90241a5e564ac5aa70be68b7b4';
export default node;
